import React, { useEffect, useState } from "react";
import {
  BranchModel,
  EnumMenuType,
  EnumPopupFunctions,
  PopupInfoModel,
  UserModel,
} from "../Managers/dataStructures";
import { fetchAllBranches, fetchAllUsers } from "../Managers/wepApiManager";
import { filterUserSearchData } from "../Managers/utilityFunctions";
import {
  createPrefTimeArray,
  getLanguage,
  noneBranchObject,
  pageIsSearchable,
} from "../Managers/dataProvider";
import { ActivityIndicator } from "../Managers/utilityComponents";
import { getCurrentUser } from "../Managers/profileManager";

interface UsersProps {
  openUserDetail: (item: PopupInfoModel) => void;
  searchValue: string;
}

export default function Users(props: UsersProps) {
  const isEnglish = getLanguage();
  let empty: BranchModel[] = [];
  empty.push(noneBranchObject());
  const [users_array, setUsersArray] = useState<UserModel[]>([]);
  const [array_branches, setArrayBranches] = useState<BranchModel[]>(empty);
  const [isActivityRunning, setIsActivityRunning] = useState<boolean>(false);

  useEffect(() => {
    setIsActivityRunning(true);
    fetchAllUsers((x) => {
      let temp: UserModel[] = x;
      for (let i = 0; i < temp.length; i++) {
        temp[i].pref_time = createPrefTimeArray();
      }
      let aIndex: number = temp.findIndex(
        (x) => x.user_id === getCurrentUser().user_id
      );
      if (aIndex !== -1) {
        temp.splice(aIndex, 1);
      }
      temp.sort((x: UserModel, y: UserModel) => {
        return x.first_name.toLocaleLowerCase() >
          y.first_name.toLocaleLowerCase()
          ? 1
          : -1;
      });
      setIsActivityRunning(false);
      setUsersArray(temp);
      fetchAllBranches((array_AllBranches) => {
        let tempBranches: BranchModel[] = array_AllBranches;
        tempBranches.push(noneBranchObject());
        setArrayBranches(tempBranches);
        if (array_AllBranches.length > 0 && temp.length > 0) {
          for (let i = 0; i < temp.length; i++) {
            const sIndex: number = array_AllBranches.findIndex(
              (x) => x.branch_id === temp[i].permanent_branch_id
            );
            if (sIndex !== -1) {
              temp[i].permanant_branch = array_AllBranches[sIndex];
            }
          }

          setUsersArray(temp);
        }
      });
    });
  }, []);

  const searchString: string = pageIsSearchable(EnumMenuType.USERS)
    ? props.searchValue
    : "";
  const filtered_array: UserModel[] = filterUserSearchData(
    users_array,
    searchString
  );

  async function addUser() {
    const item: PopupInfoModel = {
      item: null,
      ftype: EnumPopupFunctions.ADD_USER,
      array_branches: array_branches,
      callback: (item: any) => {
        let tempArray = users_array;
        tempArray.push(item as UserModel);
        setUsersArray(tempArray);
      },
    };
    props.openUserDetail(item);
  }

  function selectEditUserHandler(user: UserModel) {
    const item: PopupInfoModel = {
      item: user,
      array_branches: array_branches,
      ftype: EnumPopupFunctions.EDIT_USER,
      callback: (userInfo: UserModel) => {
        let tempArray = users_array;
        const sIndex = tempArray.findIndex(
          (x) => x.user_id === userInfo.user_id
        );
        if (sIndex !== -1) {
          tempArray[sIndex] = userInfo;
          setUsersArray(tempArray);
        }
      },
    };
    props.openUserDetail(item);
  }

  function selectUserHandler(user: UserModel) {
    const item: PopupInfoModel = {
      item: user,
      array_branches: array_branches,
      ftype: EnumPopupFunctions.USER_DETAIL,
    };

    props.openUserDetail(item);
  }

  function changePassHandler(user: UserModel) {
    const item: PopupInfoModel = {
      item: user,
      array_branches: array_branches,
      ftype: EnumPopupFunctions.CHANGE_PASSWORD_ADMIN,
    };

    props.openUserDetail(item);
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {isEnglish ? "Users" : "Anwender"}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {isEnglish
              ? "A list of all the users in your account including their name, title, email and role."
              : "Auf diese Seite finden sie alle Anwender des Systems. Sie können neue Anwender hinzufügen, Arbeitszeiten anpassen, Status ändern und deren Rolle bestimmen. "}
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            onClick={addUser}
            type="button"
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            {isEnglish ? "Add user" : "Anwender hinzufügen"}
          </button>
        </div>
      </div>

      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            {isActivityRunning ? (
              <div className="min-w-full h-20 flex flex-row items-center justify-center">
                {ActivityIndicator(1)}
              </div>
            ) : (
              <table className="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                    >
                      {isEnglish ? "Name" : "Name"}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {isEnglish ? "Title" : "Anwender Art und Rolle"}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {isEnglish ? "Status" : "Status"}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {isEnglish ? "Mobile" : "Handy Nummer"}
                    </th>
                    <th
                      scope="col"
                      className="relative py-3.5 pl-3 pr-4 sm:pr-0"
                    >
                      <span className="sr-only">Edit</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {filtered_array.map((x) => [
                    userCell(
                      x,
                      selectUserHandler,
                      selectEditUserHandler,
                      changePassHandler
                    ),
                  ])}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function userCell(
  user: UserModel,
  handler: (user: UserModel) => void,
  editHandler: (user: UserModel) => void,
  changePasshandler: (user: UserModel) => void
) {
  const isEnglish = getLanguage();
  function selectCellhandler() {
    handler(user);
  }
  function editHandler_() {
    editHandler(user);
  }
  function changePass() {
    changePasshandler(user);
  }
  return (
    <tr key={user.user_id}>
      <td
        onClick={selectCellhandler}
        className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0"
      >
        <div className="flex items-center">
          <div className="h-11 w-11 flex-shrink-0">
            <img
              className="h-11 w-11 rounded-full"
              src={user.profile_pic_url}
              alt=""
            />
          </div>
          <div className="ml-4">
            <div className="font-medium text-gray-900">
              {user.first_name + " " + user.last_name}
            </div>
            <div className="mt-1 text-gray-500">{user.employee_id}</div>
          </div>
        </div>
      </td>
      <td
        onClick={selectCellhandler}
        className="whitespace-nowrap px-3 py-5 text-sm text-gray-500"
      >
        <div className="text-gray-900">{user.role.display_name}</div>
        <div className="mt-1 text-gray-500">{user.permanant_branch.name}</div>
      </td>
      <td
        onClick={selectCellhandler}
        className="whitespace-nowrap px-3 py-5 text-sm text-gray-500"
      >
        <span
          className={
            "inline-flex items-center rounded-md  px-2 py-1 text-xs font-medium  ring-1 ring-inset " +
            user.working_status.color_scheme
          }
        >
          {user.working_status.display_name}
        </span>
      </td>
      <td
        onClick={selectCellhandler}
        className="whitespace-nowrap px-3 py-5 text-sm text-gray-500"
      >
        {user.mobilePrefix + "-" + user.mobile}
      </td>
      <td>
        <div className="whitespace-nowrap pl-3 pr-4 text-center text-sm font-medium sm:pr-0">
          <a
            onClick={editHandler_}
            href={"#ed" + user.user_id}
            className="text-indigo-600 hover:text-indigo-900"
          >
            {isEnglish ? "Edit" : "Bearbeiten"}
            <span className="sr-only">{", " + user.email_id}</span>
          </a>
        </div>
        <div className="whitespace-nowrap pl-3 pr-4 text-center text-sm font-medium sm:pr-0">
          <a
            onClick={changePass}
            href={"#cp" + user.user_id}
            className="text-indigo-600 hover:text-indigo-900"
          >
            {isEnglish ? "Change password" : "Passwortändern"}
            <span className="sr-only">{", " + user.email_id}</span>
          </a>
        </div>
      </td>
    </tr>
  );
}
